module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.54a91b06.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Regular.ttf
// module id = 706
// module chunks = 4